<template><VisitList title="ویزیت‌های تکمیل‌نشده" status="1" /></template>
<script>
import VisitList from './VisitList.vue';
export default { components: { VisitList } };
</script>
